// extracted by mini-css-extract-plugin
export var quantityInput = "_eo-0";